import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Helmet } from 'react-helmet-async';
import Header from './Header';
import Footer from './Footer';
import banner from '../images/pet-breed-banner.png';

const AllDogBreed = () => {
  const [dogBreeds, setDogBreeds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

    // Create SEO-friendly slug from title
    const slugify = (text) =>
      text
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
  
  useEffect(() => {
    const fetchDogBreeds = async () => {
      try {
        const response = await fetch('https://petcrew.in/app-admin/api/pets.php?type=all&userid=95'); // ✅ Update to your actual API
        const data = await response.json();
        console.log('API Response:', data);

        if (Array.isArray(data.Data)) {
          setDogBreeds(data.Data);
        } else {
          throw new Error('Invalid data format');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDogBreeds();
  }, []);

  return (
    <>
     <Helmet>
     <title>All Dog Breeds | PetCrew Guide to Popular Dog Breeds in India</title>
  <meta name="description" content="Explore an extensive list of dog breeds with details on temperament, grooming needs, and health tips. Find the best dog for your lifestyle." />
  <meta name="keywords" content="dog breeds India, popular dog breeds, breed guide, pet breed info, grooming needs, dog care" />
  
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            "name": "Popular Dog Breeds in India",
            "itemListElement": dogBreeds.map((breed, index) => ({
              "@type": "ListItem",
              position: index + 1,
              item: {
                "@type": "DogBreed",
                name: breed.title,
                description: breed.sort_desc,
                image: breed.image_link,
                url: `https://yourdomain.com/pet-detail/${breed.id}/${slugify(
                  breed.title
                )}`,
                location: breed.city,
              },
            })),
          })}
        </script>
      </Helmet>
      <Header />

      <div className="container py-4 all-dog-breed">
        <div className="text-center my-4">
          <img src={banner} alt="Dog Banner" className="img-fluid" />
          <h2 className="mt-4 fw-bold text-success">Most Popular Dog Breeds in India</h2>
        </div>

        {loading ? (
          <p className="text-center">Loading...</p>
        ) : error ? (
          <p className="text-center text-danger">{error}</p>
        ) : (
          <div className="row">
            {dogBreeds.map((breed) => (
              <div className="col-md-4 col-sm-6 mb-4" key={breed.id}>
                <div
                  className="card h-100 shadow-sm"
                  onClick={() => navigate(`/pet-detail/${breed.id}`)}
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    src={breed.image_link}
                    className="card-img-top"
                    alt={breed.title}
                    style={{ height: '250px', objectFit: 'cover' }}
                  />
                  <div className="card-body">
                    <span className="badge mb-2 bg-primary text-white">{breed.title}</span>
                    <h5 className="card-title">{breed.sub_title}</h5>
                    <p className="card-text">{breed.sort_desc.slice(0, 150)}...</p>
                    <p className="text-muted small">Location: {breed.city}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <Footer />
    </>
  );
};

export default AllDogBreed;
